




















import { Vue, Component, Watch } from 'vue-property-decorator';
import CommonStore from './store/CommonStore';
import MessageStore from './store/Message';
import { Message } from 'bfui';
import WaterMark from './components/waterMark.vue';

@Component({
    components: { WaterMark }
})
export default class App extends Vue {
    commonStore = CommonStore.state;
    messageState = MessageStore.state;

    get messageValue() {
        return this.messageState.message;
    }

    mounted() {
        if (document.readyState !== 'complete') {
            window.addEventListener('load', () => {
                CommonStore.changeLoad();
            });
        } else {
            CommonStore.changeLoad();
        }
    }
    created() {
        switch (this.$route.path) {
            case '/finance':
                break;
            default:
                break;
        }
    }
    @Watch('messageValue')
    watchMessageValue(value: string) {
        if (value) {
            (<any> Message).info(value);
            MessageStore.cleanMessage();
        }
    }
}
